'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _ = require('../..');

var _2 = _interopRequireDefault(_);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var Page = (_temp = _class = function (_EditorComponent) {
  _inherits(Page, _EditorComponent);

  function Page() {
    _classCallCheck(this, Page);

    return _possibleConstructorReturn(this, _EditorComponent.apply(this, arguments));
  } // constructor(props) {
  //   super(props);
  //   this.name = "Page";
  //   this.Name = "Page";
  // }


  Page.prototype.canBeParent = function canBeParent(parent) {
    return false;
  };

  Page.prototype.renderPanelView = function renderPanelView() {
    return null;
  };

  Page.prototype.renderAddButton = function renderAddButton() {
    return null;
  }; // renderMainView() {
  //   return <div
  //     {...this.getRenderProps()}
  //   >
  //     {super.renderMainView()}
  //   </div>;
  // }
  // renderChildren() {
  //   let output = super.renderChildren();
  //   let footer;
  //   const {
  //     Grid,
  //   } = this.context;
  //   const {
  //     inEditMode,
  //   } = this.getEditorContext();
  //   if (inEditMode) {
  //     let buttons = this.getBlockButtons();
  //     footer = <div>
  //       <Grid
  //         container
  //         spacing={8}
  //         style={{
  //           justifyContent: "center",
  //         }}
  //       >
  //         {buttons.map((n, index) => {
  //           const {
  //             label,
  //             ...component
  //           } = n;
  //           return <Grid
  //             key={index}
  //             item
  //           >
  //             <Button
  //               variant="raised"
  //               size="small"
  //               onClick={event => {
  //                 event.preventDefault();
  //                 event.stopPropagation();
  //                 const {
  //                   activeItem,
  //                 } = this.getEditorContext();
  //                 if (activeItem) {
  //                   activeItem.addComponent(component);
  //                 }
  //                 else {
  //                   this.addComponent(component);
  //                 }
  //               }}
  //             >
  //               {label}
  //             </Button>
  //           </Grid>
  //         })}
  //       </Grid>
  //     </div>
  //   }
  //   return <Fragment>
  //     {output}
  //     {footer}
  //   </Fragment>
  // }
  // getBlockButtons() {
  //   let buttons = [];
  //   buttons.push({
  //     name: "Section",
  //     label: "Блок",
  //     components: [
  //       {
  //         name: "Section",
  //         components: [
  //         ],
  //         props: {
  //           style: {
  //             margin: "0 auto",
  //             maxWidth: "1260px",
  //           },
  //         },
  //       },
  //     ],
  //     props: {
  //     },
  //   });
  //   buttons.push({
  //     name: "Tag",
  //     label: "Таблица",
  //     props: {
  //       tag: "div",
  //     },
  //     components: [{
  //       name: "Tag",
  //       props: {
  //         tag: "table",
  //         style: {
  //           width: "100%",
  //         },
  //       },
  //       components: [
  //         {
  //           name: "Tag",
  //           props: {
  //             tag: "tbody",
  //           },
  //           components: [
  //             {
  //               name: "Tag",
  //               props: {
  //                 tag: "tr",
  //               },
  //               components: [
  //                 {
  //                   name: "Tag",
  //                   props: {
  //                     tag: "th",
  //                   },
  //                   components: [
  //                   ],
  //                 },
  //                 {
  //                   name: "Tag",
  //                   props: {
  //                     tag: "td",
  //                   },
  //                   components: [
  //                   ],
  //                 },
  //               ],
  //             },
  //             {
  //               name: "Tag",
  //               props: {
  //                 tag: "tr",
  //               },
  //               components: [
  //                 {
  //                   name: "Tag",
  //                   props: {
  //                     tag: "th",
  //                   },
  //                   components: [
  //                   ],
  //                 },
  //                 {
  //                   name: "Tag",
  //                   props: {
  //                     tag: "td",
  //                   },
  //                   components: [
  //                   ],
  //                 },
  //               ],
  //             },
  //             {
  //               name: "Tag",
  //               props: {
  //                 tag: "tr",
  //               },
  //               components: [
  //                 {
  //                   name: "Tag",
  //                   props: {
  //                     tag: "th",
  //                   },
  //                   components: [
  //                   ],
  //                 },
  //                 {
  //                   name: "Tag",
  //                   props: {
  //                     tag: "td",
  //                   },
  //                   components: [
  //                   ],
  //                 },
  //               ],
  //             },
  //           ],
  //         },
  //       ],
  //     }
  //     ],
  //   });
  //   buttons.push({
  //     name: "Section",
  //     label: "Средний текст",
  //     components: [
  //       {
  //         name: "Tag",
  //         components: [],
  //         props: {
  //           tag: "div",
  //           // text: "Some text",
  //         },
  //       },
  //     ],
  //     props: {
  //       style: {
  //         fontSize: 20,
  //       },
  //     },
  //   });
  //   buttons.push({
  //     name: "Section",
  //     label: "Крупный текст",
  //     components: [
  //       {
  //         name: "TextArea",
  //         components: [],
  //         props: {
  //           // text: "Some text",
  //         },
  //       },
  //     ],
  //     props: {
  //       style: {
  //         fontSize: 30,
  //       },
  //     },
  //   });
  //   buttons.push({
  //     "name": "Section",
  //     label: "Пользователи",
  //     "props": {},
  //     "components": [
  //       {
  //         "name": "Connector",
  //         "props": {
  //           "first": 12,
  //           "filtersname": "filters",
  //           query: "usersConnection",
  //         },
  //         "components": [
  //           {
  //             "name": "Grid",
  //             "props": {
  //               "container": true,
  //               "spacing": 8
  //             },
  //             "components": [
  //               {
  //                 "name": "Grid",
  //                 "props": {
  //                   "item": true,
  //                   "xs": 12
  //                 },
  //                 "components": [
  //                   {
  //                     "name": "Filters",
  //                     "components": []
  //                   }
  //                 ]
  //               },
  //               {
  //                 "name": "Grid",
  //                 "props": {
  //                   "item": true,
  //                   "xs": 12
  //                 },
  //                 "components": [
  //                   {
  //                     "name": "ListView",
  //                     "components": [
  //                       {
  //                         "name": "Grid",
  //                         "props": {
  //                           "item": true,
  //                           "xs": 12,
  //                           "md": 6,
  //                           "xl": 3
  //                         },
  //                         "components": [
  //                           {
  //                             "name": "UserLink",
  //                             "props": {},
  //                             "components": []
  //                           },
  //                           {
  //                             "name": "NamedField",
  //                             "props": {
  //                               name: "fullname",
  //                             },
  //                             "components": []
  //                           },
  //                         ]
  //                       }
  //                     ]
  //                   }
  //                 ]
  //               },
  //               {
  //                 "name": "Grid",
  //                 "props": {
  //                   "item": true,
  //                   "xs": 12
  //                 },
  //                 "components": [
  //                   {
  //                     "name": "Pagination"
  //                   }
  //                 ]
  //               }
  //             ]
  //           }
  //         ]
  //       }
  //     ]
  //   });
  //   return buttons;
  // }


  return Page;
}(_2.default), _class.defaultProps = _extends({}, _2.default.defaultProps, {
  // deletable: false,
  hide_wrapper_in_default_mode: true
}), _class.Name = "Page", _temp);
exports.default = Page;
module.exports = exports['default'];